/**
 * Applique le thème d'une édition (events.theme, JSONB) sur les variables CSS.
 *
 * C'est le mécanisme qui rend l'identité visuelle configurable : l'admin
 * change une couleur en base, tout le site suit, sans build ni déploiement.
 */

/** Clés autorisées — toute autre clé est ignorée (pas d'injection CSS arbitraire). */
const THEME_VARIABLES = {
  bgBase: '--bg-base',
  bgElevated: '--bg-elevated',
  bgOverlay: '--bg-overlay',
  textPrimary: '--text-primary',
  textSecondary: '--text-secondary',
  ember300: '--ember-300',
  ember400: '--ember-400',
  ember500: '--ember-500',
  champagne400: '--champagne-400',
} as const

export type EventTheme = Partial<Record<keyof typeof THEME_VARIABLES, string>>

const COLOR_PATTERN = /^(#[0-9a-f]{3,8}|rgba?\([\d\s.,%/]+\)|hsla?\([\d\s.,%/]+\))$/i

export function applyEventTheme(theme: EventTheme | null | undefined): void {
  if (!theme) return
  const root = document.documentElement
  for (const [key, cssVariable] of Object.entries(THEME_VARIABLES)) {
    const value = theme[key as keyof EventTheme]
    if (typeof value === 'string' && COLOR_PATTERN.test(value.trim())) {
      root.style.setProperty(cssVariable, value.trim())
    }
  }
}

/**
 * Un morceau du titre, avec son traitement.
 *
 * `scale` est un pourcentage et non une mesure : la base du titre est
 * responsive, donc un segment à 145 % reste à 145 % de quelque chose qui tient
 * sur un téléphone.
 */
export interface TitleSegment {
  text: string
  font: 'display' | 'script' | 'sans'
  scale: number
  fill: 'solid' | 'champagne'
  color: string
  weight: number
  italic: boolean
  uppercase: boolean
  letter_spacing: number
  offset_y: number
  offset_x: number
  /** Faux = le segment poursuit la ligne au lieu d'en ouvrir une nouvelle. */
  new_line: boolean
}
